<template>
  <div>
    <h3 class="text-subtitle-1 font-weight-bold mb-4">
      {{ $t('onboarding.wizard.data-entry.company-name-website') }}
    </h3>

    <OnboardingFormField
      class="mb-4"
      field-key="name"
      icon="mdi-domain"
      :label="$t('onboarding.wizard.basic-info.company-name')"
    >
      <v-text-field
        :model-value="formData.name"
        id="onboarding-field-name"
        data-ai-field="name"
        :class="fieldClass('name')"
        variant="outlined"
        density="comfortable"
        rounded="lg"
        :placeholder="$t('onboarding.wizard.basic-info.company-name-placeholder')"
        hide-details
        @focus="onFieldFocus('name')"
        @update:model-value="updateField('name', $event)"
      />
    </OnboardingFormField>

    <OnboardingFormField
      class="mb-4"
      field-key="website"
      icon="mdi-web"
      :label="$t('onboarding.wizard.basic-info.website-url')"
    >
      <v-text-field
        :model-value="formData.website"
        id="onboarding-field-website"
        data-ai-field="website"
        :class="fieldClass('website')"
        variant="outlined"
        density="comfortable"
        rounded="lg"
        placeholder="www.google.com"
        hide-details
        @focus="onFieldFocus('website')"
        @update:model-value="updateField('website', $event)"
      />
    </OnboardingFormField>

    <v-divider class="mb-6" />
  </div>
</template>

<script setup lang="ts">
import { useOnboardingDataEntryContext } from '../../composables/onboardingDataEntryContext'
import OnboardingFormField from './OnboardingFormField.vue'

const { formData, updateField, fieldClass, onFieldFocus } = useOnboardingDataEntryContext()
</script>
